import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { StorageService } from "./storage.service";
import { Uris } from "./Uris";

/** Represents a global configuration entry from the backend. */
export interface GlobalConfig {
  id: number;
  name: string;
  value: string;
}

@Injectable({
  providedIn: "root"
})
export class GlobalConfigService {
  constructor(private http: HttpClient, public storageService: StorageService) {}

  /**
   * Fetches a single global configuration entry by its exact name.
   * @param name - The configuration name to look up (e.g. 'SCHEDULE_DURATION').
   * @param destroy - false para que la peticion no se cancele al navegar (componentes del layout).
   * @returns Observable emitting the matching GlobalConfig or undefined.
   */
  public getByName(name: string, destroy = true): Observable<GlobalConfig | undefined> {
    return this.http
      .get<GlobalConfig[]>(
        `${Uris.GLOBAL_CONFIG}?name=${name}`,
        this.storageService.headers(destroy)
      )
      .pipe(map((resp) => resp.find((item) => item.name === name)));
  }

  /**
   * Updates a global configuration entry by its name using the name-based endpoint.
   * @param name - The configuration name (e.g. 'SCHEDULE_DURATION').
   * @param value - The new string value to set.
   * @returns Observable emitting the updated GlobalConfig.
   */
  public patchByName(name: string, value: string): Observable<GlobalConfig> {
    return this.http.put<GlobalConfig>(
      `${Uris.GLOBAL_CONFIG}${name}/`,
      { value },
      this.storageService.headers()
    );
  }
}
